import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { useJDDetailQuery } from "../api/queries";
import { JDDetailView } from "../ui/JDDetailView";

export function JDDetailPage() {
  const { id } = useParams({ from: "/app/jd/$id" });
  const nav = useNavigate({ from: "/app/jd/$id" });
  const jd = useJDDetailQuery(id);
  const canEdit = useActionPermission(["jd:update"]);

  const handleDownloadPDF = () => {
    nav({ to: "/app/jd/$id/pdf-preview", params: { id } });
  };

  if (jd.isLoading) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex items-center justify-center py-12">
            <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
          </div>
        </Main>
      </>
    );
  }

  if (!jd.data) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex items-center justify-center py-12">
            <p className="text-muted-foreground">ບໍ່ພົບ JD</p>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />

      <Main>
        <JDDetailView
          jd={jd.data}
          onEdit={() => nav({ to: `/app/jd/${id}/edit` })}
          onDownloadPDF={handleDownloadPDF}
          canEdit={!!canEdit}
        />
      </Main>
    </>
  );
}
